<template>
  <label class="lp-checkbox" :class="{ 'is-invalid': !!error }">
    <input
      type="checkbox"
      v-bind="$attrs"
      :checked="isChecked"
      @change="onChange"
    />
    <span class="lp-checkbox__label">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'lp-checkbox',
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    // Boolean mode: v-model is the checked flag.
    // Array mode: pass `value` + bind v-model to an array of selected values.
    checked: { type: [Boolean, Array], default: false },
    value: { type: [String, Number, Boolean], default: null },
    label: { type: String, default: '' },
    error: { type: String, default: '' },
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.checked)) return this.checked.includes(this.value)
      return !!this.checked
    },
  },
  methods: {
    onChange(e) {
      if (Array.isArray(this.checked)) {
        const next = this.checked.slice()
        const i = next.indexOf(this.value)
        if (e.target.checked && i < 0) next.push(this.value)
        else if (!e.target.checked && i >= 0) next.splice(i, 1)
        this.$emit('change', next)
      } else {
        this.$emit('change', e.target.checked)
      }
    },
  },
}
</script>

<style lang="scss">
.lp-checkbox,
.lp-radio {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  font-size: var(--fs-small);
  line-height: 1.5;
  cursor: pointer;
  color: var(--text);
}
.lp-checkbox input,
.lp-radio input {
  width: 20px;
  height: 20px;
  margin-top: 1px;
  flex-shrink: 0;
  cursor: pointer;
}
.lp-checkbox.is-invalid .lp-checkbox__label { color: var(--danger); }
.lp-checkbox__label,
.lp-radio__label { line-height: 2; }
.lp-checkbox__label a,
.lp-radio__label a { color: var(--brand-deep); }
</style>
